<div class="footer">
    <a routerLink="/About/Privacy">Privacy</a> | 
    <a [routerLink]="cookieInfoLink">Cookies</a>
    <div>&copy; {{currentYear}} LifePort. All Rights Reserved.</div>
</div>
